import React, { useState } from "react";
import { withTranslation, Trans } from "react-i18next";
import Business from "./business";
import Indivisual from "./indivisual";
import SwipeableViews from 'react-swipeable-views';
import { connect } from "react-redux";
import ClientAppsDownloadBadge from "../../clientAppsDownloadBadge";
import { LoginRegisterTitle } from "../components/tabTitle";
import { Helmet } from "react-helmet";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: (global.config.isIndividualSignupActive && global.config.isIndividualTypeActive) ? 0 : 1
    }
  }

  tabChange = (tab) => {
    this.setState({
      activeTab: tab
    })
  }
  render() {
    let axis = this.props.direction == "Ltr" ? "x" : "x-reverse";

    return <div className="loginRegisterContainer">
            <Helmet
    style={[{
        "cssText": `
        .App {
          overflow-y: scroll;                  
        }
        `
    }]}
/>
      <div className="loginRegisterSwitchTab">
        {(global.config.isIndividualSignupActive && global.config.isIndividualTypeActive) && <span style={{ backgroundColor: this.state.activeTab == 0 ? global.config.colors.primaryUltraLight : "" , width: (global.config.isBusinessTypeActive ? (global.config.isBusinessSignupActive ? false : true ) : true) ? "100%" : ""  }} onClick={() => { this.tabChange(0) }} className={`PersonBusiness`} ><Trans i18nKey={"individual"}> </Trans></span>}
        {(global.config.isBusinessSignupActive && global.config.isBusinessTypeActive) && <span style={{ backgroundColor: this.state.activeTab == 1 ? global.config.colors.primaryUltraLight : "" , width: (global.config.isIndividualTypeActive ? (global.config.isIndividualSignupActive ? false : true ) : true) ? "100%" : "" }} onClick={() => { this.tabChange(1) }} className={`PersonBusiness`} ><Trans i18nKey={"Business"}> </Trans></span>}
      </div>


        {(global.config.isIndividualSignupActive && global.config.isIndividualTypeActive &&  this.state.activeTab == 0) && <Indivisual LoginIsActive={this.props.LoginIsActive} /> }
        {(global.config.isBusinessSignupActive && global.config.isBusinessTypeActive &&  this.state.activeTab == 1) && <Business />}


      <ClientAppsDownloadBadge />

    </div>;
  }
}
const mapStateToProps = (state) => ({
  authenticated: state.SharedData.access_token,
  direction: state.SharedData.direction,
});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(App));


